import { useState, useEffect } from "react";
import Table from "../../components/table";
import styles from "./styles.module.css";
import Heading from "../../components/shared-modules/Heading";
import { useMutation, useQuery } from "@tanstack/react-query";
import { CiDeliveryTruck } from "react-icons/ci";
import { getDeviceTypes, createBulkOrder } from "../../services/devices";
import { render } from "@testing-library/react";
import { formatDate } from "../../utils/helper";
import { FaArrowRightLong } from "react-icons/fa6";
import { FiDownload, FiEye } from "react-icons/fi";

import Cart from "../../components/shared-modules/order/bulk/items";

import {
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "../../components/ui/dialog";
import Button from "../../components/button-v1";
import Order from "../../components/shared-modules/order";
import {
  getDropshipedDevices,
  getInternalBulkOrderedDevices,
} from "../../services/patient/devices";

import {
  Panel,
  TabList,
  TabPanels,
  TabTrigger,
  Tabs,
} from "../../components/ui/tab";

function DevicesPage() {
  const locationId = JSON.parse(sessionStorage.getItem("current_loc"))?.id;
  const [openTrackingModal, setOpenTrackingModal] = useState(false);
  const [trackingLink, setTrackingLink] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [order, setOrder] = useState(null);

  const dropshipedOrdersQuery = useQuery(["patients-dropshiped-orders"], () => {
    return getDropshipedDevices({ locationId });
  });

  const bulkOrdersQuery = useQuery(["patients-bulk-orders"], () => {
    return getInternalBulkOrderedDevices({});
  });

  const orders = dropshipedOrdersQuery.data?.orders;

  const getColumns = () => {
    const commonColumns = [
      {
        key: "patient_name",
        label: "Patient Name",
        sorting: true,
        render: (row) => row.patient_name,
      },
      {
        key: "Patient_addres",
        label: "Patient Address",
        soring: true,
        render: (row) => row.shipping_address,
      },
      {
        key: "created_at",
        label: "Order Date",
        alignLeft: true,
        soring: true,
        render: (row) => formatDate(row?.created_at),
      },
      { key: "name", label: "Device Name", alignLeft: true },
      {
        key: "quantity",
        label: "Quantity",
        alignLeft: true,
        render: (row) => <p>1</p>,
      },
      {
        key: "status",
        label: "Status",
        alignLeft: true,
        soring: true,
        render: (row) => (
          <div
            className={styles.statusContainer}
            onClick={() => {
              setTrackingLink(row?.tracking_link);
              setOpenTrackingModal((prev) => !prev);
            }}
          >
            <div
              className={` ${styles.statusCell} ${
                row?.status === "Delivered" ? styles.option_1 : styles.option_2
              }`}
            >
              <div className={styles.status}>
                <div
                  className={
                    row?.status === "Delivered"
                      ? styles.indicator
                      : styles.indicator_yellow
                  }
                ></div>
                <p>{row?.status}</p>
                {/* <div className={styles?.info}>
                  <CiDeliveryTruck size={18} />
                </div> */}
              </div>
            </div>
            <div className={styles.tracking}>
              <p>See Tracking</p>
              <FaArrowRightLong color="#1890ff" />
            </div>
          </div>
        ),
      },
      //   {
      //     key: "shipped_at",
      //     label: "Shipped Date",
      //     alignLeft: true,
      //     render: (row) => (
      //       <p>{row?.shipped_at ? formatDate(row?.shipped_at) : "_"}</p>
      //     ),
      //   },
      {
        key: "devlivered_at",
        label: "Delivered Date",
        alignLeft: true,
        soring: true,
        render: (row) =>
          row?.delivered_at ? formatDate(row?.shipped_at) : "_",
      },
      {
        key: "location",
        label: "Location",
        alignLeft: true,
        sorting: true,
        render: (row) => row.location,
      },
    ];

    return [...commonColumns];
  };

  const bulkOrderColumns = [
    // {
    //   key: "patient_name",
    //   label: "Patient Name",
    //   sorting: true,
    //   render: (row) => row.patient_name,
    // },
    {
      key: "ordered_by_name",
      label: "Ordered By",
      soring: true,
      render: (row) => row.ordered_by_name,
    },
    {
      key: "order_number",
      label: "Order Number",
    },
    // { key: "name", label: "Device Name", alignLeft: true },
    {
      key: "quantity",
      label: "Quantity",
      alignLeft: true,
      render: (row) => (
        <p>{row.items.reduce((sum, item) => sum + item.quantity, 0)}</p>
      ),
    },
    {
      key: "status",
      label: "Status",
      alignLeft: true,
      soring: true,
      render: (row) => (
        <div
          className={styles.statusContainer}
          // onClick={() => {
          //   setTrackingLink(row?.tracking_link);
          //   setOpenTrackingModal((prev) => !prev);
          // }}
        >
          <div
            className={` ${styles.statusCell} ${
              row?.status === "Delivered" ? styles.option_1 : styles.option_2
            }`}
          >
            <div className={styles.status}>
              <div
                className={
                  row?.status === "Delivered"
                    ? styles.indicator
                    : styles.indicator_yellow
                }
              ></div>
              <p>{row?.status}</p>
              {/* <div className={styles?.info}>
                <CiDeliveryTruck size={18} />
              </div> */}
            </div>
          </div>
          {/* TRACKING LINK */}

          {/* <div className={styles.tracking}>
            <p>See Tracking</p>
            <FaArrowRightLong color="#1890ff" />
          </div> */}
        </div>
      ),
    },
    {
      key: "created_at",
      label: "Order Date",
      alignLeft: true,
      soring: true,
      render: (row) => formatDate(row?.ordered_at),
    },
    {
      key: "devlivered_at",
      label: "Delivered Date",
      alignLeft: true,
      soring: true,
      render: (row) =>
        row?.delivered_at ? formatDate(row?.delivered_at) : "_",
    },
    {
      key: "location",
      label: "Location",
      alignLeft: true,
      sorting: true,
      render: (row) => row.location_name,
    },
    {
      key: "actions",
      label: "Actions",
      alignLeft: false,
      sorting: false,
      render: (row) => (
        <div className={styles.actionButtonsContainer}>
          <Button
            variant="normal"
            size="small"
            onClick={() => {
              setShowDetailModal(true);
              setOrder(row?.items);
            }}
          >
            <FiEye className="icon-default-size " />
          </Button>
        </div>
      ),
    },
  ];

  return (
    <section className={styles.container}>
      <Tabs defaultValue="dropshiped-orders">
        <TabList>
          <TabTrigger value="dropshiped-orders">Dropshiped</TabTrigger>
          <TabTrigger value="bulk-orders">Bulk</TabTrigger>
        </TabList>
        <TabPanels>
          <Panel value="dropshiped-orders">
            <div className={styles.billingContainer}>
              <Heading
                title={"Dropshiped Orders"}
                bodyHeight="auto"
                content={
                  <div>
                    {/* Tabs Section */}
                    {/* <div className={styles.tabsContainer}>
              <Button
                isRound={true}
                size="medium"
                variant={category.ccm ? "default" : "ghost"}
                onClick={() => handleBillingTypeChange("ccm")}
              >
                CCM
              </Button>
              <Button
                isRound={true}
                size="medium"
                variant={category.rpm ? "default" : "ghost"}
                onClick={() => handleBillingTypeChange("rpm")}
              >
                RPM
              </Button>
            </div> */}

                    {/* Table Section */}
                    <div className={styles.tableWrapper}>
                      <Table
                        columns={getColumns()}
                        data={orders}
                        isRowClickable={false}
                        showCheckboxes={false}
                        horizontal={true}
                        loading={dropshipedOrdersQuery.isLoading}
                        height={580}
                      />
                    </div>
                  </div>
                }
              ></Heading>
              <Dialog
                open={openTrackingModal}
                setOpen={() => setOpenTrackingModal(false)}
              >
                <DialogContent>
                  <DialogHeader>
                    <DialogTitle>Tracking</DialogTitle>
                  </DialogHeader>
                  <DialogBody>
                    <div className={styles.trackingContainer}>
                      <div className={styles.trackingContent}>
                        {trackingLink ? (
                          <p
                            className={styles.trackingLink}
                            onClick={() => {
                              if (trackingLink)
                                window.open(trackingLink, "_blank");
                            }}
                          >
                            {trackingLink}
                          </p>
                        ) : (
                          <p>No Tracking Link</p>
                        )}
                      </div>
                    </div>
                  </DialogBody>
                  <DialogFooter>
                    <Button
                      variant="ghost"
                      onClick={() => setOpenTrackingModal(false)}
                    >
                      Close
                    </Button>
                  </DialogFooter>
                </DialogContent>
              </Dialog>
            </div>
          </Panel>
          <Panel value="bulk-orders">
            <div className={styles.billingContainer}>
              <Heading
                title={"Bulk Orders"}
                bodyHeight="auto"
                actions={[
                  <Button variant="ghost" onClick={() => setIsOpen(true)}>
                    <img
                      src="/icons/plus.svg"
                      alt="category-icon"
                      style={{ width: "14px", height: "14px" }}
                    />
                    Order Device
                  </Button>,
                ]}
                content={
                  <div>
                    {/* Tabs Section */}
                    {/* <div className={styles.tabsContainer}>
              <Button
                isRound={true}
                size="medium"
                variant={category.ccm ? "default" : "ghost"}
                onClick={() => handleBillingTypeChange("ccm")}
              >
                CCM
              </Button>
              <Button
                isRound={true}
                size="medium"
                variant={category.rpm ? "default" : "ghost"}
                onClick={() => handleBillingTypeChange("rpm")}
              >
                RPM
              </Button>
            </div> */}

                    {/* Table Section */}
                    <div className={styles.tableWrapper}>
                      <Table
                        columns={bulkOrderColumns}
                        data={bulkOrdersQuery.data?.orders}
                        isRowClickable={false}
                        showCheckboxes={false}
                        horizontal={true}
                        loading={dropshipedOrdersQuery.isLoading}
                        height={580}
                      />
                    </div>
                  </div>
                }
              ></Heading>
              {/* <Dialog
                open={openTrackingModal}
                setOpen={() => setOpenTrackingModal(false)}
              >
                <DialogContent>
                  <DialogHeader>
                    <DialogTitle>Tracking</DialogTitle>
                  </DialogHeader>
                  <DialogBody>
                    <div className={styles.trackingContainer}>
                      <div className={styles.trackingContent}>
                        {trackingLink ? (
                          <p
                            className={styles.trackingLink}
                            onClick={() => {
                              if (trackingLink)
                                window.open(trackingLink, "_blank");
                            }}
                          >
                            {trackingLink}
                          </p>
                        ) : (
                          <p>No Tracking Link</p>
                        )}
                      </div>
                    </div>
                  </DialogBody>
                  <DialogFooter>
                    <Button
                      variant="ghost"
                      onClick={() => setOpenTrackingModal(false)}
                    >
                      Close
                    </Button>
                  </DialogFooter>
                </DialogContent>
              </Dialog> */}
              {/* <Order isOpen={isOpen} setIsOpen={() => setIsOpen(false)} /> */}
            </div>
          </Panel>
        </TabPanels>
      </Tabs>
      <Order isOpen={isOpen} setIsOpen={() => setIsOpen(false)} />

      <Dialog open={showDetailModal} setOpen={() => setShowDetailModal(false)}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Order Items</DialogTitle>
          </DialogHeader>
          <DialogBody>
            <section>
              <p>Ordered items are listed below</p>
              <Cart
                devices={order?.map((_order) => {
                  const { device_type_name, ...rest } = _order;
                  return {
                    ...rest,
                    name: device_type_name,
                  };
                })}
              />
            </section>
          </DialogBody>
          <DialogFooter>
            <Button variant="ghost" onClick={() => setShowDetailModal(false)}>
              Close
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </section>
  );
}

export default DevicesPage;
